import { useState } from "react";
import { FaHandHoldingUsd, FaHandsHelping, FaFileAlt, FaMoneyCheckAlt, FaIdCard } from "react-icons/fa";
import { Card, Carousel, CarouselIndicators, Modal } from "../components/carousel";

import icon_1 from "../assets/icons/Adli_Tip_Teknolojileri.png";
import icon_2 from "../assets/icons/Afetlere_Hazirlik.png";
import icon_3 from "../assets/icons/Akilli_Sehir.jpg";
import icon_4 from "../assets/icons/Biyometrik_Sistemler.png";
import icon_5 from "../assets/icons/Butunlesik_Guvenlik_Sistemler.png";
import icon_6 from "../assets/icons/Deprem_Oncesi_Sonrasi.png";
import icon_7 from "../assets/icons/Gozetleme.jpg";
import icon_8 from "../assets/icons/Iletisim_Haberlesme.jpg";
import icon_9 from "../assets/icons/Siber_Guvenlik_ve_Dijital_Guven_Teknolojileri.png";
import icon_10 from "../assets/icons/Yapay_Zeka_ve_Karar_Destek_Sistemleri.jpg";
import icon_11 from "../assets/icons/KBRN_ve_Kritik_Tehdit_Teknolojileri.png";
import icon_12 from "../assets/icons/Otonom_Sistemler_Robotik_ve_İleri_Sensör_Teknolojileri.png";
import icon_13 from "../assets/icons/iletisim_ve_haberlesme_v2.png";

const Anasayfa = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = [
  {
    alt: "İleri Güvenlik Teknolojileri",
    title: "İleri Güvenlik Teknolojileri",
    src: icon_5,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">İleri takip ve gözetleme</li>
        <li className="list-group-item">Video analitik ve görüntü işleme</li>
        <li className="list-group-item">Tehdit ve şüpheli davranış analizi</li>
        <li className="list-group-item">Mobil gözetleme sistemleri</li>
        <li className="list-group-item">Uzaktan izleme ve komuta merkezleri</li>
        <li className="list-group-item">Akıllı kamera ve sensör sistemleri</li>
        <li className="list-group-item">Güvenlik operasyon platformları</li>
      </ul>
  },
  {
    alt: "Siber Güvenlik ve Dijital Güven Teknolojileri",
    title: "Siber Güvenlik ve Dijital Güven Teknolojileri",
    src: icon_9,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Siber güvenlik ve siber istihbarat</li>
        <li className="list-group-item">Tehdit avcılığı ve saldırı tespiti</li>
        <li className="list-group-item">Kimlik doğrulama ve erişim yönetimi</li>
        <li className="list-group-item">Kriptografi ve şifreleme</li>
        <li className="list-group-item">Blockchain tabanlı sistemler</li>
        <li className="list-group-item">Dijital kimlik ve veri güvenliği</li>
        <li className="list-group-item">Güvenli bulut ve Zero Trust mimarileri</li>
      </ul>
  },
  {
    alt: "Yapay Zekâ ve Karar Destek Sistemleri",
    title: "Yapay Zekâ ve Karar Destek Sistemleri",
    src: icon_10,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Yapay zekâ uygulamaları</li>
        <li className="list-group-item">Makine öğrenmesi ve derin öğrenme</li>
        <li className="list-group-item">Büyük veri analitiği</li>
        <li className="list-group-item">Tahmine dayalı analiz</li>
        <li className="list-group-item">Otonom karar destek sistemleri</li>
        <li className="list-group-item">Generatif yapay zekâ</li>
        <li className="list-group-item">Operasyonel karar destek</li>
        <li className="list-group-item">Risk analiz ve senaryo yönetimi</li>
      </ul>
  },
  {
    alt: "Biyometrik ve Kimlik Teknolojileri",
    title: "Biyometrik ve Kimlik Teknolojileri",
    src: icon_4,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Yüz, ses, parmak izi, iris-retina tanıma</li>
        <li className="list-group-item">Jest ve mimik tanıma</li>
        <li className="list-group-item">Yürüyüş ve davranış analizi</li>
        <li className="list-group-item">Çoklu biyometrik doğrulama</li>
        <li className="list-group-item">Davranışsal biyometri</li>
        <li className="list-group-item">Dijital kimlik yönetimi</li>
        <li className="list-group-item">Temassız erişim sistemleri</li>
      </ul>
  },
  {
    alt: "İletişim / Haberleşme Teknolojileri",
    title: "İletişim / Haberleşme Teknolojileri",
    src: icon_13,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Güvenli haberleşme sistemleri</li>
        <li className="list-group-item">Uydu haberleşme</li>
        <li className="list-group-item">Taktik ve kritik görev haberleşmesi</li>
        <li className="list-group-item">Kablosuz iletişim teknolojileri</li>
        <li className="list-group-item">Şifreleme ve kriptografi çözümleri</li>
        <li className="list-group-item">IoT güvenliği ve ağ güvenliği</li>
        <li className="list-group-item">5G / 6G güvenli altyapılar</li>
        <li className="list-group-item">Acil durum haberleşme sistemleri</li>
      </ul>
  },
  {
    alt: "Akıllı Şehir, Trafik ve Kritik Altyapı Teknolojileri",
    title: "Akıllı Şehir, Trafik ve Kritik Altyapı Teknolojileri",
    src: icon_3,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Akıllı şehir çözümleri</li>
        <li className="list-group-item">Akıllı ulaşım ve trafik yönetimi</li>
        <li className="list-group-item">Trafik radarları ve akıllı kavşaklar</li>
        <li className="list-group-item">Plaka ve araç tanıma sistemleri</li>
        <li className="list-group-item">Akıllı park ve ulaşım sistemleri</li>
        <li className="list-group-item">Kritik altyapı güvenliği</li>
        <li className="list-group-item">Enerji ve altyapı güvenliği</li>
        <li className="list-group-item">Dijital ikiz ve şehir veri platformları</li>
      </ul>
  },
  {
    alt: "Adli Tıp ve Olay Yeri Teknolojileri",
    title: "Adli Tıp ve Olay Yeri Teknolojileri",
    src: icon_1,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Olay yeri inceleme</li>
        <li className="list-group-item">Adli tıp ve adli teknoloji</li>
        <li className="list-group-item">Biyolojik materyal analizi</li>
        <li className="list-group-item">Dijital adli bilişim</li>
        <li className="list-group-item">Adli görüntü ve ses analizi</li>
        <li className="list-group-item">Delil yönetim sistemleri</li>
        <li className="list-group-item">Trafik ve sigorta adli incelemeleri</li>
        <li className="list-group-item">Narkotik analiz teknolojileri</li>
      </ul>
  },
  {
    alt: "Göç, Sınır ve Kamu Güvenliği Teknolojileri",
    title: "Göç, Sınır ve Kamu Güvenliği Teknolojileri",
    src: icon_7,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Sınır güvenliği sistemleri</li>
        <li className="list-group-item">Göç yönetimi ve izleme sistemleri</li>
        <li className="list-group-item">Akıllı sınır ve geçiş kontrol sistemleri</li>
        <li className="list-group-item">Biyometrik geçiş ve kimlik doğrulama </li>
        <li className="list-group-item">Risk analiz ve izleme sistemleri</li>
        <li className="list-group-item">Kamu düzeni ve kalabalık yönetimi</li>
        <li className="list-group-item">Kritik tesis ve kişi güvenliği</li>
      </ul>
  },
  {
    alt: "Afet, Kriz ve Acil Durum Yönetimi Teknolojileri",
    title: "Afet, Kriz ve Acil Durum Yönetimi Teknolojileri",
    src: icon_6,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Erken uyarı ve izleme sistemleri</li>
        <li className="list-group-item">Afet ve kriz yönetimi platformları</li>
        <li className="list-group-item">Arama-kurtarma teknolojileri</li>
        <li className="list-group-item">İHA destekli afet yönetimi</li>
        <li className="list-group-item">Konum tespit ve izleme sistemleri</li>
        <li className="list-group-item">Duvar arkası görüntüleme</li>
        <li className="list-group-item">Afet simülasyon ve senaryo analizleri</li>
        <li className="list-group-item">Afet sonrası lojistik ve koordinasyon</li>
      </ul>
  },
  {
    alt: "KBRN ve Kritik Tehdit Tespit Teknolojileri",
    title: "KBRN ve Kritik Tehdit Tespit Teknolojileri",
    src: icon_11,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">Dekontaminasyon sistemleri</li>
        <li className="list-group-item">Numune alma ve tanımlama teknolojileri</li>
        <li className="list-group-item">Nükleer tehdit izleme</li>
        <li className="list-group-item">Patlayıcı tespiti ve imha sistemleri</li>
        <li className="list-group-item">İstenmeyen madde tespiti</li>
        <li className="list-group-item">X-Ray ve MM dalga tarama sistemleri</li>
        <li className="list-group-item">Gelişmiş tarayıcı ve dedektörler</li>
        <li className="list-group-item">Tehlikeli madde sensör sistemleri</li>
        <li className="list-group-item">KBRN koruma ve analiz çözümleri</li>
      </ul>
  },
  {
    alt: "Otonom Sistemler, Robotik ve İleri Sensör Teknolojileri",
    title: "Otonom Sistemler, Robotik ve İleri Sensör Teknolojileri",
    src: icon_12,
    description:
      <ul className="list-group list-group-flush">
        <li className="list-group-item">İHA / UAV sistemleri</li>
        <li className="list-group-item">Sualtı ve su üstü otonom sistemler</li>
        <li className="list-group-item">Robotik müdahale ve devriye sistemleri</li>
        <li className="list-group-item">Sensör füzyonu ve akıllı sensör ağları</li>
        <li className="list-group-item">Lidar, radar ve elektro-optik sistemler</li>
        <li className="list-group-item">Uzaktan algılama ve konumlandırma</li>
        <li className="list-group-item">Otonom navigasyon ve kontrol</li>
        <li className="list-group-item">Akıllı robotik platformlar</li>
      </ul>
  }]

  return (
    <div className="mt-4 pt-4">
      
      <Carousel />

      <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Odak Teknolojiler</h2>
          </div>
        </div>

        <div className="cards">
          {cardData.map((card, index) => (
            <Card
              key={index}
              alt={card.alt}
              src={card.src}
              title={card.title}
              onOpen={() => setSelectedCard(card)}
            />
          ))}
        </div>

        <Modal
          show={!!selectedCard}
          title={selectedCard?.title}
          description={selectedCard?.description}
          onClose={() => setSelectedCard(null)}
        />



        {/* <div className="cards">
          {cardData.map((card, index) => (
            <React.Fragment key={`card-${index}`}>
              <Card
                key={`card-${index}`}
                unique={index}
                alt={card.alt}
                src={card.src}
                title={card.title}
                description={card.description}
              />

              <Modal 
                unique={index}
                title={card.title}
                description={card.description}
              />
            </React.Fragment>
          ))}
        </div> */}
      </section>
      
      {/* <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Haberler</h2>
          </div>
        </div>

        <CarouselIndicators />

      </section> */}

    </div>
  );
};

export default Anasayfa;
